/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EnumerationOptionDto } from './EnumerationOptionDto';
import {
    EnumerationOptionDtoFromJSON,
    EnumerationOptionDtoFromJSONTyped,
    EnumerationOptionDtoToJSON,
} from './EnumerationOptionDto';

/**
 * 
 * @export
 * @interface NamedEnumerationValueDto
 */
export interface NamedEnumerationValueDto {
    /**
     * 
     * @type {string}
     * @memberof NamedEnumerationValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {EnumerationOptionDto}
     * @memberof NamedEnumerationValueDto
     */
    value: EnumerationOptionDto;
    /**
     * 
     * @type {string}
     * @memberof NamedEnumerationValueDto
     */
    $type?: NamedEnumerationValueDtoTypeEnum;
}


/**
 * @export
 */
export const NamedEnumerationValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoNamedEnumerationValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NamedEnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NamedEnumerationValueDtoTypeEnum = typeof NamedEnumerationValueDtoTypeEnum[keyof typeof NamedEnumerationValueDtoTypeEnum];


/**
 * Check if a given object implements the NamedEnumerationValueDto interface.
 */
export function instanceOfNamedEnumerationValueDto(value?: unknown): value is NamedEnumerationValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NamedEnumerationValueDtoTypeEnum)[0];
}

export function NamedEnumerationValueDtoFromJSON(json: any): NamedEnumerationValueDto {
    return NamedEnumerationValueDtoFromJSONTyped(json, false);
}

export function NamedEnumerationValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NamedEnumerationValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': EnumerationOptionDtoFromJSON(json['value']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NamedEnumerationValueDtoToJSON(value?: NamedEnumerationValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'value': EnumerationOptionDtoToJSON(value.value),
        '$type': value.$type,
    });
}

